import { CantonViewModel, LocationsApi, LocationViewModel } from '@ail/locations-api'
import { ApiException } from '@ail/orders-api'
import { createApi } from '@reduxjs/toolkit/query/react'
import { USER_MANAGER } from '../../auth/userManager'
import { Constants } from '../../helpers/Constants'
import { getBaseQuery } from './apiQuery'

const client = new LocationsApi({
  baseUrl: Constants.locationsEndPoint,
  getToken: async () => {
    const user = await USER_MANAGER.getUser()
    return user?.access_token ?? ''
  },
})
export const locationsApi = createApi({
  reducerPath: 'locationsApi',
  baseQuery: getBaseQuery<ApiException>(),
  endpoints: (builder) => ({
    getLocations: builder.query<LocationViewModel[], { match?: string; latitude?: number; longitude?: number }>({
      query: ({ match, latitude, longitude }) => client.getLocations(match, latitude, longitude),
    }),
    getCantons: builder.query<CantonViewModel[], void>({
      query: () => client.getCantons(),
    }),
  }),
})

export const { useGetLocationsQuery, useGetCantonsQuery } = locationsApi
